<template>
  <div class="w-full">
    <DatatableReportV3
      ref="datatable"
      title="Billing Tool"
      :source="source"
      :config="config"
      :filters="filters"
      no-download
      bulk-select
      bulk-select-key="checkbox_row_value"
      :bulk-select-ids="selectedValues"
      @update:bulk-select-ids="handleUpdateBulkSelectIds"
    >
      <template #actions>
        <div class="ml-3">
          <Button
            text="Charge"
            :disabled="!selectedValues.length"
            @click="toggleConfirm"
          />
        </div>
      </template>
    </DatatableReportV3>
    <ActionConfirmationModal
      v-if="confirmModal"
      :modal-contents="modalContents"
      @hide-modal="toggleConfirm"
      @on-submit="handleCharge"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { EventBus } from "@/lib/event_bus.js";

import Button from "@/components/Button.vue";
import ActionConfirmationModal from "@/Reports/ActionConfirmationModal.vue";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";

export default {
  components: {
    DatatableReportV3,
    ActionConfirmationModal,
    Button
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    },
    selectionSubmitLink: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      selectedValues: [],
      confirmModal: false,
      config: {
        order: [[3, "desc"]],
        columns: [
          { data: "invoice" },
          { data: "job" },
          {
            data: "finalized_at",
            title: "Completed"
          },
          { data: "customer" },
          { data: "customer_email", title: "Email" },
          { data: "customer_phone", title: "Phone" },
          { data: "location_name", title: "Location Name", orderable: false },
          {
            data: "service_address",
            title: "Service Address",
            orderable: false
          },
          {
            data: "last_payment",
            title: "Last Payment",
            searchable: false
          },
          {
            data: "payment_method",
            title: "Last Method",
            orderable: false,
            searchable: false
          },
          { data: "notes", searchable: false },
          {
            data: "total",
            title: "Amount",
            className: "text-right",
            searchable: false
          },
          { data: "balance", className: "text-right", searchable: false },
          {
            data: "on_file",
            className: "text-center",
            title: "On File",
            filterName: "with_payment_method",
            orderable: false,
            searchable: false
          }
        ]
      }
    };
  },
  computed: {
    modalContents() {
      return {
        message: `Charging ${
          this.selectedValues.length > 1
            ? `these ${this.selectedValues.length} invoices`
            : "this invoice"
        } will attempt to collect payment with the payment method on file.`,
        title: "Confirm Charge",
        success_message:
          "Invoice(s) submitted for charge.  Please check the status in a few minutes.",
        hide_input: true
      };
    }
  },
  methods: {
    ...mapActions(["submitDatatableSelections"]),
    handleUpdateBulkSelectIds(ids) {
      this.selectedValues = ids;
    },
    handleCharge() {
      // Action expects a url to POST to and a data payload
      this.submitDatatableSelections({
        link: this.selectionSubmitLink,
        data: this.selectedValues
      }).then(() => {
        // Reset selected rows
        this.selectedValues = [];
        // Automatically refresh the datatable on success
        EventBus.$emit("refresh-datatable");
        window.notify.success(this.modalContents.success_message);
        this.toggleConfirm();
      });
    },
    toggleConfirm() {
      this.confirmModal = !this.confirmModal;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .on-file-filter-width {
  min-width: 70px;
}
</style>
